import color from 'color'

const RUBY_RED = '#e31e25'
const RUBY_GREY = '#2d2d2d'

export default {
  colors: {
    primary: RUBY_RED,
    primaryDark: color(RUBY_RED).darken(0.15).hex(),
    primaryLight: color(RUBY_RED).lighten(0.4).hex(),
    grey: RUBY_GREY,
    shadow: color('black').alpha(0.1).toString(),
  },
  base: {
    spacing: 16,
    borderRadius: 0,
    shadowLength: 5,
  },
  fonts: {
    serif: '"Abhaya Libre", serif',
    sansSerif: '"Voces", sans-serif',
  }
}
